import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { generateApiPath, getItem } from '#app/Handler/api';
import { StateType } from '#app/Store';
import ShopEntryPoints from '#app/entrypoints/shop';
import { ShopCheckOpening } from '#app/typings/shop';

type HookReturn = {
  shop?: ShopCheckOpening;
  loading: boolean;
};

const useCheckOpening = (openRequired: boolean): HookReturn => {
  const navigate = useNavigate();
  const authenticationReducer = useSelector((state: StateType) => state.AuthenticationReducer);
  const { data: shop, isLoading } = useSWR<ShopCheckOpening>(
    generateApiPath(ShopEntryPoints.checkOpening, { shopId: authenticationReducer.shopSelected as string }),
    getItem,
  );

  useEffect(() => {
    if (openRequired && shop && !shop.open) {
      dispatch(
        SnackbarOpen({
          text: 'Vous devez ouvrir votre caisse pour accéder à cet onglet.',
          variant: 'error',
        }),
      );
      navigate(getRoutePathname('shop'));
    }
  }, [shop]);

  return {
    shop,
    loading: isLoading,
  };
};

export default useCheckOpening;
